import { render, staticRenderFns } from "./GiftTypeBoxes.vue?vue&type=template&id=5e92056d&scoped=true&"
import script from "./GiftTypeBoxes.vue?vue&type=script&lang=js&"
export * from "./GiftTypeBoxes.vue?vue&type=script&lang=js&"
import style0 from "./GiftTypeBoxes.vue?vue&type=style&index=0&id=5e92056d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e92056d",
  null
  
)

export default component.exports